import { i18n } from 'i18n';
import HeaderWithTooltip from '../../../../common/components/ThreatListTable/TableHeaderWithTooltip';
import type {
  CellThreatGroupProps,
  HeaderThreatGroupProps,
} from '../../../../threat.types';

export type DetectionDateHeaderProps = {
  text: string;
};

export const DetectionDateHeader = ({ text }: DetectionDateHeaderProps) => {
  const tooltip = i18n.t(
    'The most recent detection date for each grouped threat event',
  );

  return <HeaderWithTooltip text={text} tooltip={tooltip} tooltipWidth={250} />;
};

export const renderDetectionDateHeader = (
  info: HeaderThreatGroupProps<string>,
) => {
  const text = info.column.columnDef.meta?.displayName;
  if (!text) return null;

  return <DetectionDateHeader text={text} />;
};

export const renderDetectionDateCell = (info: CellThreatGroupProps<string>) => {
  const date = info.getValue();
  if (!date) return '-';

  return i18n.format.date(date);
};
